import {createContext as $9XrEB$createContext, useState as $9XrEB$useState, useCallback as $9XrEB$useCallback, useMemo as $9XrEB$useMemo, useContext as $9XrEB$useContext, useEffect as $9XrEB$useEffect} from "react";
import $9XrEB$macrostrathyper from "@macrostrat/hyper";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;



var $30Gl3 = parcelRequire("30Gl3");

var $ig5HY = parcelRequire("ig5HY");
const $9f093bb8daf24897$var$PatternDefsContext = (0, $9XrEB$createContext)(null);
const $9f093bb8daf24897$var$GeologicPatternDefs = function(props) {
    let { patternIDs: patternIDs, scalePattern: scalePattern } = props;
    const UUID = props.UUID ?? (0, $ig5HY.useUUID)();
    return (0, $9XrEB$macrostrathyper)("defs", Array.from(patternIDs).map(function(id, i) {
        if (id === -1) return null;
        let sz = 100;
        if (scalePattern != null) sz *= scalePattern(id);
        return (0, $9XrEB$macrostrathyper)((0, $30Gl3.GeologicPattern), {
            key: i,
            prefix: UUID,
            id: id,
            width: sz,
            height: sz
        });
    }));
};
function $9f093bb8daf24897$export$2162bbed7004f389(props) {
    /** A next-generation provider for lithology patterns in the context of an SVG.
   *  We should consider generalizing this further to work without needing the "resolveID" function.
   */ const { scalePattern: scalePattern, children: children } = props;
    const [patternIDs, setPatternIDs] = (0, $9XrEB$useState)(new Set());
    const trackPattern = (0, $9XrEB$useCallback)((p)=>{
        if (patternIDs.has(p)) return;
        let newSet = new Set(patternIDs);
        newSet.add(p);
        setPatternIDs(newSet);
    }, [
        patternIDs
    ]);
    const value = (0, $9XrEB$useMemo)(()=>{
        return {
            trackPattern: trackPattern
        };
    }, [
        trackPattern
    ]);
    return (0, $9XrEB$macrostrathyper)((0, $ig5HY.UUIDProvider), (0, $9XrEB$macrostrathyper)($9f093bb8daf24897$var$PatternDefsContext.Provider, {
        value: value
    }, (0, $9XrEB$macrostrathyper)("g.patterns", [
        (0, $9XrEB$macrostrathyper)($9f093bb8daf24897$var$GeologicPatternDefs, {
            scalePattern: scalePattern,
            patternIDs: patternIDs
        }),
        children
    ])));
}
function $9f093bb8daf24897$export$85aacc253e576bcf(patternID, fallback = "#aaa") {
    const ctx1 = (0, $9XrEB$useContext)((0, $30Gl3.GeologicPatternContext));
    const ctx = (0, $9XrEB$useContext)($9f093bb8daf24897$var$PatternDefsContext);
    const UUID = (0, $ig5HY.useUUID)();
    (0, $9XrEB$useEffect)(()=>{
        ctx?.trackPattern(patternID);
    }, [
        patternID,
        ctx
    ]);
    let v = ctx1?.resolvePattern(patternID);
    if (v == null) return fallback;
    return `url(#${UUID}-${patternID})`;
}


//# sourceMappingURL=column-patterns.99a43a03.js.map
